var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2027_510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1692 3H19.54L27.4699 11.2774V27.3518C27.4699 29.365 25.8451 31 23.832 31H10.1692C8.16628 31 6.53125 29.365 6.53125 27.3518V6.63795C6.53121 4.63503 8.16628 3 10.1692 3Z",
    fill: "#00733B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5293 3V11.2058H27.4694L19.5293 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0518 18.6362L22.7678 19.9061H22.8018L23.5263 18.6362H24.8473L23.5433 20.818L24.8984 22.9999H23.5433L22.8018 21.7044H22.7678L22.0263 22.9999H20.6797L22.0178 20.818L20.7223 18.6362H22.0518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1388 20C19.1275 19.8579 19.0742 19.7471 18.979 19.6676C18.8853 19.588 18.7425 19.5483 18.5508 19.5483C18.4286 19.5483 18.3285 19.5632 18.2504 19.593C18.1737 19.6214 18.1168 19.6605 18.0799 19.7102C18.043 19.7599 18.0238 19.8167 18.0224 19.8806C18.0195 19.9332 18.0288 19.9808 18.0501 20.0234C18.0728 20.0646 18.1083 20.1022 18.1566 20.1363C18.2049 20.169 18.2667 20.1988 18.342 20.2258C18.4173 20.2528 18.5067 20.2769 18.6104 20.2983L18.9684 20.375C19.2099 20.4261 19.4165 20.4936 19.5884 20.5774C19.7603 20.6612 19.9009 20.7599 20.0103 20.8735C20.1197 20.9858 20.1999 21.1122 20.2511 21.2528C20.3036 21.3934 20.3306 21.5468 20.332 21.713C20.3306 22 20.2589 22.2429 20.1168 22.4417C19.9748 22.6406 19.7717 22.7919 19.5075 22.8956C19.2447 22.9992 18.9286 23.0511 18.5593 23.0511C18.18 23.0511 17.8491 22.995 17.5664 22.8828C17.2852 22.7706 17.0664 22.598 16.9102 22.365C16.7553 22.1306 16.6772 21.8309 16.6758 21.4659H17.8008C17.8079 21.5994 17.8413 21.7116 17.9009 21.8025C17.9606 21.8934 18.0444 21.9623 18.1523 22.0092C18.2617 22.0561 18.3917 22.0795 18.5423 22.0795C18.6687 22.0795 18.7745 22.0639 18.8597 22.0326C18.945 22.0014 19.0096 21.9581 19.0536 21.9027C19.0977 21.8473 19.1204 21.784 19.1218 21.713C19.1204 21.6463 19.0984 21.588 19.0558 21.5383C19.0146 21.4872 18.9464 21.4417 18.8512 21.4019C18.756 21.3608 18.6275 21.3224 18.4656 21.2869L18.0309 21.1931C17.6445 21.1093 17.3398 20.9694 17.1168 20.7734C16.8952 20.5759 16.7852 20.3068 16.7866 19.9659C16.7852 19.6889 16.859 19.4467 17.0082 19.2393C17.1587 19.0305 17.3668 18.8679 17.6325 18.7514C17.8995 18.6349 18.2056 18.5767 18.5508 18.5767C18.9031 18.5767 19.2077 18.6356 19.4648 18.7535C19.7219 18.8714 19.9201 19.0376 20.0593 19.2521C20.1999 19.4652 20.271 19.7144 20.2724 20H19.1388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3574 22.9999V18.6362H14.5421V22.0453H16.3063V22.9999H13.3574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0518 18.6362L10.7678 19.9061H10.8018L11.5263 18.6362H12.8473L11.5433 20.818L12.8984 22.9999H11.5433L10.8018 21.7044H10.7678L10.0263 22.9999H8.67969L10.0178 20.818L8.7223 18.6362H10.0518Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2027_510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon3);
export default __webpack_public_path__ + "static/media/file_icon3.5d5dba8cdf4bd60bd444214dee24e3ce.svg";
export { ForwardRef as ReactComponent };